import { createApi } from "@reduxjs/toolkit/query/react";
import { getBaseQuery, handleSessionExpiredError } from "../../utils/auth";
import { OneclickInscription, TransbankInscriptionToken } from "./types";

// Define a service using a base URL and expected endpoints
export const payApi = createApi({
  reducerPath: "payApi",
  baseQuery: getBaseQuery("/debts"),
  endpoints: (builder) => ({
    getTBInscriptionToken: builder.mutation<TransbankInscriptionToken, void>({
      query: () => ({
        url: "/onelick-inscription",
        method: "POST",
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    confirmTBInscription: builder.mutation<void, string>({
      query: (token) => ({
        url: `/onelick-inscription/confirm/${token}`,
        method: "POST",
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    getInscriptions: builder.query<OneclickInscription[], void>({
      query: () => ({
        url: "/onelick-inscriptions",
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    removeInscriptions: builder.mutation<void, string>({
      query: (token) => ({
        url: `/onelick-inscription/remove/${token}`,
        method: "DELETE",
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTBInscriptionTokenMutation,
  useConfirmTBInscriptionMutation,
  useGetInscriptionsQuery,
  useRemoveInscriptionsMutation,
} = payApi;
